"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPermissionsSync = exports.hasPermissions = exports.CLIENT_TYPE_ROLE_MAP = void 0;
var appRoles_1 = require("./appRoles");
Object.defineProperty(exports, "CLIENT_TYPE_ROLE_MAP", { enumerable: true, get: function () { return appRoles_1.CLIENT_TYPE_ROLE_MAP; } });
__exportStar(require("./permissions"), exports);
var permissionsEvaluation_1 = require("./permissionsEvaluation");
Object.defineProperty(exports, "hasPermissions", { enumerable: true, get: function () { return permissionsEvaluation_1.hasPermissions; } });
Object.defineProperty(exports, "hasPermissionsSync", { enumerable: true, get: function () { return permissionsEvaluation_1.hasPermissionsSync; } });
__exportStar(require("./role-utils"), exports);
//# sourceMappingURL=index.js.map